import { CellPlugin } from '@react-page/editor';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { DateFormatter, DateOnlyFormatter } from '../../../../components/Formatters';

// use a type here, not an interface
type Data = {
  label: string,
  value: string
}

const TransactionDatePropertyPlugin: CellPlugin<Data> = {
  Renderer: ({ data }) => (
      <Row>
        <Col><strong>{data.label}</strong></Col>
        <Col>{DateOnlyFormatter(data.value)}</Col>
      </Row>
  ),
  id: 'transactionDatePropertyPlugin',
  title: 'Transaction Date Property',
  description: 'Transaction Date Property.',
  version: 1,
  controls: {
    type: 'autoform',
    schema: {
      properties: {
        label: {
          type: 'string',
          default: 'Transaction Date',
        },
      },
      required: ['label'],
    },
  },
};

export default TransactionDatePropertyPlugin;